import createRouter from 'router5';
import loggerPlugin from 'router5/plugins/logger';
import browserPlugin from 'router5/plugins/browser';

const routes = [
  {
    name: 'qb',
    path: '/qb',
    children: [
      { name: 'status', path: '/status' },
      { name: 'setup', path: '/setup' },
    ]
  },
];

const router = createRouter(routes, {
  defaultRoute: 'qb.status'
}).usePlugin(loggerPlugin)
  .usePlugin(browserPlugin({ useHash: true }));

export default router;



// WEBPACK FOOTER //
// ./src/router.js